import { memo, type CSSProperties } from 'react';

import plusIconGc from '../../assets/plus_gc.png';
import plusIconGcWebp from '../../assets/plus_gc.webp';

export const PlusIconGc = memo(
  ({ className, style, alt }: { className?: string; style?: CSSProperties; alt?: string }) => {
    return (
      <picture className={className} style={{ display: 'flex', ...style }}>
        <source srcSet={plusIconGcWebp} type="image/webp" />
        <source srcSet={plusIconGc} type="image/png" />
        <img alt={alt || 'Plus icon'} src={plusIconGc} />
      </picture>
    );
  },
);

PlusIconGc.displayName = 'PlusIconGc';
